<script lang="ts">
	import Card from "#lib/Card.svelte";
	import type { AvtaleDiscountSection } from "#lib/types/avtale.js";
	import { PortableText } from "@portabletext/svelte";

	interface Props {
		discountSection: AvtaleDiscountSection;
	}

	let { discountSection }: Props = $props();
</script>

<div class="mx-edge-x mb-8 tablet:mb-11">
	<div class="bg-[#E6F0FF] rounded p-4">
		<h2>{discountSection.title}</h2>
		<PortableText value={discountSection.content?.filter(Boolean) ?? []} />
		{#if discountSection.discounts}
			<div
				class="grid gap-4"
				class:tablet:grid-cols-2={discountSection.discounts.length > 1}
				class:laptop:grid-cols-3={discountSection.discounts.length === 3}
				class:laptop:grid-cols-4={discountSection.discounts.length >= 4}
			>
				{#each discountSection.discounts as discount (discount._key)}
					<Card
						title={discount.title}
						pictureObject={discount.image}
						href={discount.link}
						hrefLabel={discount.linkText}
						size={discountSection.discounts.length === 1 ? "full" : null}
						class="p-2"
					>
						<PortableText value={discount.description?.filter(Boolean) ?? []} />
					</Card>
				{/each}
			</div>
		{/if}
	</div>
</div>
